<template>
<ItpButton
  :spinning="actions.submit.isRunning"
  variant="primary"
  :size="size"
  :text="messages.bntText"
  :tooltip="messages.btnTooltip"
  @click.prevent.stop="evh_7315092382398562_clickPreventStop($event, {})"
>
</ItpButton>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BtnReportInvoiceData extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  resource!: object;

  @Watch('resource')
  onResource(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("resource")
  }

  @Prop({
    type: String,
    default: "Kérem erősítse meg az adatszolgáltatás indítását.\n",
  })
  confirmMessage!: string;

  @Watch('confirmMessage')
  onConfirm_message(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("confirmMessage")
  }

  @Prop({
    type: String,
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  messages!: any;
  ux!: any;
  dataMembers = ['messages', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          bntText: "NAV adatszolgáltatás",
          btnTooltip: "NAV adatszolgáltatás",
        }
        ,
        ux: null,
      },
    }
  }

  async act_7315092382398562_emit_7118_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7315092382398562_emit_7118, alias=undefined
    return {
      event: "success",
    }
  }

  async act_7315092382398562_request_7116_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_7315092382398562_request_7116, alias=submit
    return {
      operation: "sync_invoice",
      data: { id: this.resource.id, target: 'nav' },
    }
  }

  async act_7315092382398562_request_7116_getConfirm($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_7315092382398562_request_7116, alias=submit
    return {
      header: "NAV adatszolgáltatás",
      message: this.confirmMessage,
      btnOk: "Adatszolgáltatás indítása",
      btnCancel: "Mégsem",
      severity: "warning",
    }
  }

  async evh_7315092382398562_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_emit_7118: actions.EmitAction;
    evh_7315092382398562_success_7117: actions.EventHandlerImpl;
    act_7315092382398562_request_7116: actions.RequestAction;
    evh_7315092382398562_clickPreventStop_7115: actions.EventHandlerImpl;
    evh_7315092382398562_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_emit_7118 = new actions.EmitAction(
      {
        actionArgs: this.act_7315092382398562_emit_7118_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_success_7117 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_emit_7118,
        event: "success",
        displayName: "emit",
      }
    );
    const act_7315092382398562_request_7116 = new actions.RequestAction(
      {
        actionArgs: this.act_7315092382398562_request_7116_getActionArgs,
        confirm: this.act_7315092382398562_request_7116_getConfirm,
        displayName: "submit",
        events: [evh_7315092382398562_success_7117],
      }
    );
    const evh_7315092382398562_clickPreventStop_7115 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_request_7116,
        event: "click.prevent.stop",
        displayName: "submit",
      }
    );
    const evh_7315092382398562_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_clickPreventStop_7115],
      }
    );
    return {
      act_7315092382398562_emit_7118,
      evh_7315092382398562_success_7117,
      act_7315092382398562_request_7116,
      evh_7315092382398562_clickPreventStop_7115,
      evh_7315092382398562_clickPreventStop,
      submit: act_7315092382398562_request_7116,
    }
  }
}

Vue.component("BtnReportInvoiceData", BtnReportInvoiceData);

</script>